import {
  MAIN_APP_MONITORS_REWARD_URL,
  MAIN_APP_WELCOME_CREDITS_URL,
  MAIN_APP_WELCOME_URL,
} from '@/shared/constants';

export type CheckoutSource =
  | 'onboarding'
  | 'onboarding-credits'
  | 'onboarding-reward';

export const CHECKOUT_SOURCE_REDIRECT: Record<CheckoutSource, string> =
  Object.freeze({
    onboarding: MAIN_APP_WELCOME_URL,
    'onboarding-credits': MAIN_APP_WELCOME_CREDITS_URL,
    'onboarding-reward': MAIN_APP_MONITORS_REWARD_URL,
  });

export const parseCheckoutSource = (
  raw: string | null,
): CheckoutSource | undefined => {
  switch (raw) {
    case 'onboarding':
    case 'onboarding-credits':
    case 'onboarding-reward':
      return raw;
    default:
      return undefined;
  }
};

export const checkoutSourceRedirectUrl = (
  source: CheckoutSource | undefined,
): string | undefined =>
  source ? CHECKOUT_SOURCE_REDIRECT[source] : undefined;

export const trialSourceParam = (
  source: CheckoutSource | undefined,
): 'onboarding-reward' | undefined =>
  source === 'onboarding-reward' ? source : undefined;
